import EventCalendar from "../components/EventCalendar";
import { FaRegUserCircle,FaRegCheckCircle, FaBirthdayCake, FaUserFriends, FaStar, FaRegHeart, FaHeart } from "react-icons/fa";
import { IoCalendarOutline } from "react-icons/io5";
import { CiCalendar } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../context/UserContext";
import { useContext, useEffect, useState } from "react";
import { base_url } from '../url_variables';
import axios from 'axios';
import { useCookies } from "react-cookie";
import { GridLoader } from "react-spinners";
import {TopBar} from '../components/topbar';
import { MenuContext } from "../context/MenuContext";
import { ReviewModal } from "../components/review_modal";
import { TransactionModal } from "../components/transaction_modal";
import { TbPigMoney } from "react-icons/tb";
import { BiMoneyWithdraw } from "react-icons/bi";
import { ApartmentModal } from "../components/apartment_modal";
import { InventoryModal } from "../components/inventory_modal";
import { InventorySupplyModal } from "../components/supply_modal";
import { InventoryDeductModal } from "../components/deduct_modal";


export default function Inventory() {
    const navigate = useNavigate();
    const {userProfile, logOutFunction} = useContext(UserContext);
    const [cookies] = useCookies();
    const [formFields, setFormFields] = useState({});
    const [bookingList, setBookingList] = useState([]);
    const [pageLoading, setPageLoading] = useState(true);
    const [offset, setOffset] = useState(0);
    const [pagination, setPagination] = useState('');
    const { menuOpen, setMenuOpen } = useContext(MenuContext)
    const [showModal, setShowModal] = useState(false);
    const [showSupplyModal, setShowSupplyModal] = useState(false);
    const [showDeductModal, setShowDeductModal] = useState(false);
    const [itemUpdating, setItem] = useState({});
    const [apartmentReview, setApartmentReview] = useState({});
    const [pageData, setPageData] = useState({});

    useEffect(() => {
        if (menuOpen) setMenuOpen(false);
        getData();
    }, [])

    useEffect(() => {
        getData();
    }, [offset])

    function changePage(type) {
        if (type == "next") {
            setOffset(offset + 20);
        } else {
            setOffset(offset - 20);
        }
    }

    async function getData() {
        const formData = new FormData();
        Object.entries(formFields).forEach(([key, value]) => {
          formData.append(key, value);
        });
        formData.append('offset', offset);
        setPageLoading(true)
        try {
            const response = await axios.post(base_url + '/get-inventory-items.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    accountid: cookies?.userProfile?.main_id,
                },
            });
            if (response.data.code == 403) {
                logOutFunction()
            }
            setPageLoading(false)
            if (response.data.status) {
              setBookingList(response.data.records);
              setPageData({ branches: response.data.branches })
            } else {

            }
        } catch (error) {
          setPageLoading(false)
        }
    }

  return (
    <div className="flex flex-col rounded-[10px] min-h-full bg-white">
      {showModal &&
            <InventoryModal 
                setShowModal={setShowModal}
                getData={getData}
            />
      }
      {showSupplyModal &&
        <InventorySupplyModal
            setShowSupplyModal={setShowSupplyModal}
            getData={getData}
            item={itemUpdating}
        />
      }
      {showDeductModal &&
        <InventoryDeductModal
            setShowDeductModal={setShowDeductModal}
            getData={getData}
            item={itemUpdating}
        /> 
      }
      {pageLoading && (
      <div className="flex items-center justify-center h-full w-[-webkit-fill-available] z-[99] bg-[#ffffff] fixed opacity-[0.9]">
        <GridLoader
            color={'#037684'}
            loading={true}
            size={20}
            aria-label="Loading Spinner"
            data-testid="loader"
        />
      </div>
      )}
        {/* <h2 className="text-2xl text-[#037684] font-bold mb-4">Welcome, {userProfile?.name}</h2> */}
        <TopBar title={`Welcome, ${cookies?.userProfile?.name}`} />
        <div className="py-6 px-6 flex flex-col justify-start">
            <div className="flex mt-7 flex-row items-center justify-between">
                <h2 className="text-xl md:text-2xl text-black font-bold">{'Manage Inventory'}</h2>
                <div className="flex gap-x-2">
                    <button onClick={() => setShowModal(true) } className="bg-primary text-white flex flex-row items-center justify-evenly w-auto h-[35px] px-5 rounded-xl shadow-md shrink-0 text-sm md:text-md font-cormorant-bold">
                        <span className="text-white font-cormorant-bold text-sm md:text-md update-price">Create New Item</span>
                    </button>
                    {/* <button onClick={() => setShowTransactionModal(true) } className="bg-primary text-white flex flex-row items-center justify-evenly w-auto h-[35px] px-5 rounded-xl shadow-md shrink-0 text-sm md:text-md font-cormorant-bold">
                        <span className="text-white font-cormorant-bold text-sm md:text-md update-price">Add New Branch</span>
                    </button> */}
                </div>
            </div>
            <div className='overflow-x-auto mt-5'>
                <table className="w-full table-auto border-collapse text-sm md:text-[15px]">
                    <thead className="bg-gray-50 border-b">
                    <tr>
                        <th className="hidden md:table-cell px-2 py-4">
                            <div className="flex items-center gap-1">#</div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex items-center gap-1">Item Name</div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex items-center gap-1">Quantity Left</div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex items-center gap-1">Last Restocked</div>
                        </th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody className="text-gray-700">
                        {bookingList?.map((row, index) => (
                            <tr
                            key={index}
                            className={index % 2 === 0 ? "bg-white animate-fadeIn" : "bg-gray-50 animate-fadeIn"}
                            >
                                <td className="hidden md:table-cell px-2 py-2">
                                    {++index}
                                </td>
                                <td className="px-2 py-2 font-semibold">
                                    {row.item_name}
                                </td>
                                <td className="px-2 py-2 font-semibold">
                                    {row.inventory_balance}
                                </td>
                                <td className="px-2 py-2">
                                    {row.last_restocked}
                                </td>
                                <td className="px-2 py-2">
                                    <div className="flex flex-col md:flex-row gap-y-1 md:gap-y-0 gap-x-1">
                                        <div onClick={() => { setShowSupplyModal(true);setItem(row) }} className="flex items-center justify-center cursor-pointer px-2 py-1 md:px-3 md:py-2 rounded-[5px] border border-1 border-primary bg-primary text-white font-semibold text-center text-xs">{'Add Supply'}</div>
                                        <div onClick={() => { setShowDeductModal(true);setItem(row) }} className="flex items-center justify-center cursor-pointer px-2 py-1 md:px-3 md:py-2 rounded-[5px] border border-1 border-[#ff0000] bg-[#ff0000] text-white font-semibold text-center text-xs">{'Deduct Stock'}</div>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className='w-full flex justify-end mt-6'>
                <div className='flex flex-col items-center'>
                    <div className="flex items-center space-x-2 border border-gray-300 rounded-lg px-1 py-1 w-fit bg-white">
                        <button
                            onClick={() => changePage('prev')}
                            className="text-sm font-semibold px-3 py-1 rounded bg-gray-100 hover:bg-gray-200"
                        >
                            Prev.
                        </button>
                        <button
                            onClick={() => changePage('next')}
                            className="text-sm font-semibold px-3 py-1 rounded bg-gray-100 hover:bg-gray-200"
                        >
                            Next
                        </button>
                    </div> 
                    <label className='text-sm mt-2'>{pagination}</label>
                </div>
            </div>
        </div>
    </div>
  );
}
